<template>
  <v-card >
    <v-card-text >
      <div v-if="false" class="d-flex align-center flex-wrap ga-2 mb-2">
        <v-btn-toggle v-model="mesure" density="compact" mandatory>
          <v-btn value="qte">Quantités</v-btn>
          <v-btn value="montant">Montant HT</v-btn>
        </v-btn-toggle>

        <v-btn
          v-if="themeSelectionne"
          size="small"
          variant="text"
          prepend-icon="mdi-arrow-left"
          @click="themeSelectionne = null"
        >
          Tous les thèmes
        </v-btn>
      </div>

      <div v-if="pieItems.length === 0" class="text-medium-emphasis py-6 text-center">
        Aucune donnée à afficher.
      </div>

      <template v-else>
        <v-pie
          :title="titre"
          class="pie-petite-legende"
          hide-slice
          :inner-cut="53"
          animation
          :palette="palette"
          :size="size"
          tooltip
          reveal
          
          :items="pieItems"
        >
        <!-- :legend="{ position: 'right' }" -->
          <template #center>
            <div class="text-center">
              <div class="text-display-medium">{{ totalValue }}</div>
              <div class="opacity-70 mt-1 mb-n1">Total</div>
            </div>
          </template>
        </v-pie>
        <div v-if="false" class="d-flex flex-wrap ga-1 mt-2">
          <v-chip
            v-for="item in pieItems"
            :key="item.key"
            size="small"
            :variant="themeSelectionne ? 'outlined' : 'tonal'"
            @click="!themeSelectionne && (themeSelectionne = item.key)"
          >
            {{ item.title }} : {{ item.value }}
          </v-chip>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { VPie } from 'vuetify/labs/VPie';
/**
 * Utilisation : <FrepPieChart :frep="frep" />
 * frep.articles a la forme { THEME: { REFERENCE: { CODEBARRE: { ..., "AAAAMMJJ": { qte } } } } }
 */
const props = defineProps({
  statDialog: { type: Boolean, default: true },
  frep: { type: Object, required: true },
  size: { type: Number, default: 150 },
  palette: {
    type: Array,
    default: () => ['#048BA8', '#99C24D', '#F18F01', '#D65A4B', '#6A4C93',
                    '#F9A03F', '#2D6A4F', '#E63946', '#1D3557', '#457B9D'],
  },
})

const themeSelectionne = ref(null) // null = vue par thème
const mesure = ref('qte')          // 'qte' | 'montant'

// Si le thème sélectionné disparaît de la commande, on revient à la vue globale
watch(
  () => props.frep?.articles,
  articles => {
    if (themeSelectionne.value && !articles?.[themeSelectionne.value]) themeSelectionne.value = null
  },
  { deep: true }
)

const libelleMesure = computed(() => (mesure.value === 'qte' ? 'Quantités' : 'Montant HT'))

const titre = computed(() =>
  themeSelectionne.value
    ? `${libelleMesure.value} du thème ${themeSelectionne.value}`
    : `${libelleMesure.value} par thème`
)

// Quantité d'un article = somme des qte des dates de livraison (clés AAAAMMJJ)
const qteArticle = article => {
  const dates = Object.entries(article || {})
    .filter(([cle, v]) => /^\d{8}$/.test(cle) && v && typeof v === 'object')

  // Pas de dates de livraison : on prend directement le champ qte
  if (dates.length === 0) return Number(article?.qte || 0)

  return dates.reduce((total, [, v]) => total + Number(v.qte || 0), 0)
}
const valeurArticle = article =>
  mesure.value === 'qte'
    ? qteArticle(article)
    : qteArticle(article) * Number(article?.achat_euro || 0)

const valeurReference = codesBarres =>
  Object.values(codesBarres || {}).reduce((total, a) => total + valeurArticle(a), 0)

const premier = obj => Object.values(obj || {})[0]
const arrondi = n => Math.round(n * 100) / 100

const pieItems = computed(() => {
  const articles = props.frep?.articles || {}

  // Niveau 1 : par thème
  if (!themeSelectionne.value) {
    return Object.entries(articles)
      .map(([codeTheme, references]) => ({
        key: codeTheme,
        title: `${codeTheme} - ${premier(premier(references))?.theme || ''}`,
        value: arrondi(Object.values(references || {}).reduce((t, cb) => t + valeurReference(cb), 0)),
      }))
      .filter(item => item.value > 0)
  }

  // Niveau 2 : par référence dans le thème sélectionné
  return Object.entries(articles[themeSelectionne.value] || {})
    .map(([reference, codesBarres]) => ({
      key: reference,
      title: `${reference} - ${premier(codesBarres)?.designation || ''}`,
      value: arrondi(valeurReference(codesBarres)),
    }))
    .filter(item => item.value > 0)
})

const totalValue = computed(() => arrondi(pieItems.value.reduce((t, item) => t + item.value, 0)))
</script>
<style scoped>
.pie-petite-legende :deep(.v-pie__legend) {
  font-size: 0.1;   
  gap: 1px;             
}
.pie-petite-legende :deep(.v-pie__legend .v-chip) {
  font-size: 0.1rem;
  height: 15px;
  padding: 0 1px;
}
.pie-petite-legende :deep(.v-pie__legend .v-chip__underlay),
.pie-petite-legende :deep(.v-pie__legend .v-chip__overlay) {
  display: none;
}
</style>